import { createMigrate } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import storageLocal from 'redux-persist/lib/storage';

import migrations from './migrations';
import { isDevelopment } from 'utils/environment';

export const cartConfig = {
  key: 'cart',
  version: 1,
  storage: storageSession,
  blacklist: ['loading', 'isUpdating', 'editingProduct'],
};
export const authConfig = {
  key: 'auth',
  version: 1,
  storage: storageLocal,
  whitelist: ['resetPasswordEmail', 'user.email'],
};
export const checkoutConfig = {
  key: 'checkout',
  version: 1,
  storage: storageSession,
  blacklist: [
    'checkoutPaymentMethods',
    'orderCreateResponse',
    'loading',
    'error',
  ],
  migrate: createMigrate(migrations.checkout, { debug: isDevelopment }),
};

export const transactionConfig = {
  key: 'transaction',
  version: 1,
  storage: storageSession,
  blacklist: ['search', 'isLoading', 'detailsIsLoading'],
};
export const transferConfig = {
  key: 'transfer',
  storage: storageSession,
  blacklist: ['search', 'isLoading', 'detailsIsLoading'],
};
export const payoutConfig = {
  key: 'payout',
  version: 2,
  storage: storageSession,
  blacklist: ['search', 'isLoading', 'detailsIsLoading'],
  migrate: createMigrate(migrations.payout, { debug: isDevelopment }),
};
export const refundConfig = {
  key: 'refund',
  storage: storageSession,
  blacklist: ['search', 'isLoading', 'detailsIsLoading'],
};
export const clientConfig = {
  key: 'client',
  storage: storageSession,
  blacklist: ['search', 'isLoading', 'detailsIsLoading'],
};
export const disputeConfig = {
  key: 'dispute',
  storage: storageSession,
  blacklist: ['search', 'isLoading', 'detailsIsLoading'],
};
export const companyConfig = {
  key: 'company',
  version: 1,
  storage: storageSession,
  blacklist: ['hopRedirecting'],
};
export const integrationConfig = {
  key: 'integration',
  storage: storageSession,
  blacklist: ['search', 'isLoading', 'detailsIsLoading'],
};
export const webhookConfig = {
  key: 'webhook',
  version: 1,
  storage: storageSession,
  migrate: createMigrate(migrations.webhook, { debug: isDevelopment }),
  blacklist: ['search', 'isLoading', 'detailsIsLoading'],
};
